/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/sui/SuiBox";
import SuiTypography from "components/sui/SuiTypography";

// Timeline context
import { TimelineProvider } from "components/sui/SuiTimeline/context";

function TimelineList({ title, dark, children }) {
  return (
    <TimelineProvider value={dark}>
      <Card>
        <SuiBox bgColor={dark ? "dark" : "white"} variant="gradient">
          {title && (
            <SuiBox pt={3} px={3}>
              <SuiTypography variant="h6" fontWeight="medium" color={dark ? "white" : "dark"}>
                {title}
              </SuiTypography>
            </SuiBox>
          )}
          <SuiBox p={2}>{children}</SuiBox>
        </SuiBox>
      </Card>
    </TimelineProvider>
  );
}

// Setting default values for the props of TimelineList
TimelineList.defaultProps = {
  title: false,
  dark: false,
};

// Typechecking props for the TimelineList
TimelineList.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  dark: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default TimelineList;
